class EVWFinalProduct {
  constructor(root) {
    this.root = root;
    this.slides = [...root.querySelectorAll('[data-evw-slide]')];
    this.thumbs = [...root.querySelectorAll('[data-evw-thumb]')];
    this.status = root.querySelector('[data-evw-gallery-status]');
    this.modal = root.querySelector('[data-evw-offer-modal]');
    this.index = 0;
    this.opener = null;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.querySelector('[data-evw-prev]')?.addEventListener('click', () => this.show(this.index - 1));
    root.querySelector('[data-evw-next]')?.addEventListener('click', () => this.show(this.index + 1));
    this.thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => this.show(index, true)));
    root.querySelector('[data-evw-gallery-stage]')?.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
    });

    root.querySelectorAll('[data-evw-offer-open]').forEach(button => button.addEventListener('click', () => this.openOffer(button)));
    root.querySelectorAll('[data-evw-offer-close]').forEach(button => button.addEventListener('click', () => this.closeOffer()));
    root.querySelectorAll('[data-evw-scroll-buy]').forEach(button => button.addEventListener('click', () => this.scrollToBuy()));
    root.querySelectorAll('[data-evw-youtube]').forEach(button => button.addEventListener('click', () => this.loadYoutube(button)));

    if (this.modal) {
      this.modal.addEventListener('click', event => { if (event.target === this.modal) this.closeOffer(); });
      this.modal.addEventListener('close', () => this.afterModalClose());
    }

    this.initStickyBar();
    this.updateStatus();
  }

  show(next, scrollThumb = false) {
    if (!this.slides.length) return;
    this.index = (next + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, index) => { const active = index === this.index; slide.hidden = !active; slide.classList.toggle('is-active', active); });
    this.thumbs.forEach((thumb, index) => { const active = index === this.index; thumb.classList.toggle('is-active', active); thumb.setAttribute('aria-current', active ? 'true' : 'false'); });
    if (scrollThumb) this.thumbs[this.index]?.scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
    this.updateStatus();
  }

  updateStatus() {
    if (this.status) this.status.textContent = this.slides.length ? `${this.index + 1} / ${this.slides.length}` : '';
  }

  openOffer(trigger) {
    if (!this.modal || this.modal.open) return;
    this.opener = trigger || document.activeElement;
    if (typeof this.modal.showModal === 'function') this.modal.showModal(); else this.modal.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
    window.requestAnimationFrame(() => this.modal.querySelector('input, select, textarea, button:not([data-evw-offer-close])')?.focus());
  }

  closeOffer() {
    if (!this.modal || !this.modal.open) return;
    if (typeof this.modal.close === 'function') this.modal.close(); else { this.modal.removeAttribute('open'); this.afterModalClose(); }
  }

  afterModalClose() {
    document.documentElement.style.overflow = '';
    if (this.opener instanceof HTMLElement && this.opener.isConnected) this.opener.focus();
    this.opener = null;
  }

  scrollToBuy() {
    const target = this.root.querySelector('.evw-final-buy');
    target?.scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'start' });
  }

  initStickyBar() {
    const bar = this.root.querySelector('[data-evw-mobilebar]');
    const form = this.root.querySelector('.evw-final-actions');
    if (!bar || !form || !('IntersectionObserver' in window)) return;
    this.observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      bar.hidden = !(entry.boundingClientRect.bottom < 0 && !entry.isIntersecting);
    }, { threshold: 0 });
    this.observer.observe(form);
  }

  loadYoutube(button) {
    const videoId = button.dataset.videoId || '';
    if (!/^[A-Za-z0-9_-]{6,20}$/.test(videoId)) return;
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
    iframe.title = button.getAttribute('aria-label') || 'YouTube video';
    iframe.loading = 'lazy';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;
    button.replaceChildren(iframe);
  }

  destroy() { this.observer?.disconnect(); if (this.modal?.open) this.closeOffer(); }
}

function initEVWFinal(scope = document) {
  scope.querySelectorAll('[data-evw-final]').forEach(root => {
    if (root.dataset.evwFinalReady) return;
    root.dataset.evwFinalReady = 'true';
    root.evwFinal = new EVWFinalProduct(root);
  });
}

document.addEventListener('DOMContentLoaded', () => initEVWFinal());
document.addEventListener('shopify:section:load', event => initEVWFinal(event.target));
document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-evw-final]').forEach(root => root.evwFinal?.destroy()));
